/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Show_Filmstrip_HelpInputs */

const en_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show a film strip of video frames around the selected event's start time in the timeline. Desktop only.`)
};

const fr_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher une bande de séquences vidéo autour de l'heure de début de l'événement sélectionné dans la chronologie. Version ordinateur uniquement.`)
};

const de_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeigt einen Filmstreifen mit Videoframes um den Startzeitpunkt des ausgewählten Ereignisses in der Zeitleiste an. Nur für Desktop-Computer.`)
};

const it_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra una sequenza di fotogrammi video intorno all'istante di inizio dell'evento selezionato nella timeline. Solo per desktop.`)
};

const ru_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображение видеоленты, отображающей время начала выбранного события, на временной шкале. Только для настольных компьютеров.`)
};

const es_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestra una secuencia de fotogramas de vídeo alrededor del momento de inicio del evento seleccionado en la línea de tiempo. Solo para ordenadores de escritorio.`)
};

const zh_cn2_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在时间轴上，围绕选定事件的开始时间显示一段视频帧条。仅限桌面端。`)
};

const ja_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムライン上で選択したイベントの開始時刻付近のビデオフレームをフィルムストリップ形式で表示します。デスクトップ版のみ。`)
};

const hi_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन में चयनित इवेंट के प्रारंभ समय के आसपास के वीडियो फ्रेम की एक फिल्म स्ट्रिप दिखाएं। केवल डेस्कटॉप पर उपलब्ध।`)
};

const pt_pt2_options_editor_show_filmstrip_help = /** @type {(inputs: Options_Editor_Show_Filmstrip_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibe uma sequência de fotogramas de vídeo em torno do horário de início do evento selecionado na linha do tempo. Disponível apenas para computador.`)
};

/**
* | output |
* | --- |
* | "Show a film strip of video frames around the selected event's start time in the timeline. Desktop only." |
*
* @param {Options_Editor_Show_Filmstrip_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_show_filmstrip_help = /** @type {((inputs?: Options_Editor_Show_Filmstrip_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Show_Filmstrip_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_show_filmstrip_help(inputs)
	if (locale === "de") return de_options_editor_show_filmstrip_help(inputs)
	if (locale === "it") return it_options_editor_show_filmstrip_help(inputs)
	if (locale === "ru") return ru_options_editor_show_filmstrip_help(inputs)
	if (locale === "es") return es_options_editor_show_filmstrip_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_show_filmstrip_help(inputs)
	if (locale === "ja") return ja_options_editor_show_filmstrip_help(inputs)
	if (locale === "hi") return hi_options_editor_show_filmstrip_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_show_filmstrip_help(inputs)
	return en_options_editor_show_filmstrip_help(inputs)
});